<template>
  <section class="section has-text-centered">
    <span class="icon is-large">
      <i class="fas fa-3x fa-spinner fa-pulse"></i>
    </span>
    <br/>
    <br/>
    {{text}}
  </section>
</template>

<script>
export default {
  name: 'loading-indicator',
  props: {
    text: {
      type: String,
      default: 'Loading..'
    }
  }
}
</script>
